<ng-container *ngIf="loader$ | async as loader">
  <ng-container *ngIf="loader.status">
    <div class="blackout active"></div>

    <div class="container-loader">
      @if (loader.type === LOADER_TYPE.PROGRESS) {
        <loader-progress-bar [loader]="loader"></loader-progress-bar>
      }

      @if (loader.type === LOADER_TYPE.INFINITE) {
        <infinite-loader [loader]="loader"></infinite-loader>
      }

      <div class="text" [innerHTML]="loader.text"></div>
    </div>
  </ng-container>
</ng-container>
